import PeopleGrid from './PeopleGrid';

export { type PeopleGridProps } from './PeopleGrid';
export default PeopleGrid;
